/**
 * modules
 */
import angular from 'angular';
import services from './services/register';
import uiBootstrap from 'angular-ui-bootstrap';

const moduleName = 'auth',
    module = angular.module(moduleName, [
        uiBootstrap,
    ]);

services(module);

export default moduleName;



// WEBPACK FOOTER //
// ./src/auth/auth.module.js